/**
 * AI Tools Data
 * This file contains the metadata for all AI tools displayed on the AI Tools page.
 * Translation keys are used for i18n support.
 */

export const aiToolsData = [
    {
        id: 'quicklrc',
        name: 'QuickLRC',
        url: 'https://www.quicklrc.com/lrc-generator/upload',
        descriptionKey: 'aiTools.quicklrc.description',
        priceKey: 'aiTools.quicklrc.price',
        priceDetailsKey: 'aiTools.quicklrc.priceDetails',
        icon: '🎵',
        isFree: false,
        category: 'music',
        firstReleaseYear: 2023,
        lastVersionYear: 2024
    },
    {
        id: 'suno',
        name: 'Suno',
        url: 'https://suno.com',
        descriptionKey: 'aiTools.suno.description',
        priceKey: 'aiTools.suno.price',
        priceDetailsKey: 'aiTools.suno.priceDetails',
        icon: '🎶',
        isFree: false,
        category: 'music',
        firstReleaseYear: 2023,
        lastVersionYear: 2024
    },
    {
        id: 'replit',
        name: 'Replit',
        url: 'https://replit.com',
        descriptionKey: 'aiTools.replit.description',
        priceKey: 'aiTools.replit.price',
        priceDetailsKey: 'aiTools.replit.priceDetails',
        icon: '💻',
        isFree: false,
        category: 'development',
        firstReleaseYear: 2016,
        lastVersionYear: 2024
    },
    {
        id: 'kling',
        name: 'Kling',
        url: 'https://klingai.com',
        descriptionKey: 'aiTools.kling.description',
        priceKey: 'aiTools.kling.price',
        priceDetailsKey: 'aiTools.kling.priceDetails',
        icon: '🎬',
        isFree: false,
        category: 'video',
        firstReleaseYear: 2024,
        lastVersionYear: 2024
    },
    {
        id: 'midjourney',
        name: 'Midjourney',
        url: 'https://www.midjourney.com',
        descriptionKey: 'aiTools.midjourney.description',
        priceKey: 'aiTools.midjourney.price',
        priceDetailsKey: 'aiTools.midjourney.priceDetails',
        icon: '🎨',
        isFree: false,
        category: 'image',
        firstReleaseYear: 2022,
        lastVersionYear: 2024
    },
    {
        id: 'nanobanana',
        name: 'Nano Banana',
        url: 'https://nanobananaimage.app',
        descriptionKey: 'aiTools.nanobanana.description',
        priceKey: 'aiTools.nanobanana.price',
        priceDetailsKey: 'aiTools.nanobanana.priceDetails',
        icon: '🍌',
        isFree: false,
        category: 'image',
        firstReleaseYear: 2024,
        lastVersionYear: 2024
    },
    {
        id: 'freepik',
        name: 'Freepik',
        url: 'https://www.freepik.com',
        descriptionKey: 'aiTools.freepik.description',
        priceKey: 'aiTools.freepik.price',
        priceDetailsKey: 'aiTools.freepik.priceDetails',
        icon: '🖼️',
        isFree: false,
        category: 'image',
        firstReleaseYear: 2010,
        lastVersionYear: 2024
    },
    {
        id: 'elevenlabs',
        name: 'ElevenLabs',
        url: 'https://elevenlabs.io/app/home',
        descriptionKey: 'aiTools.elevenlabs.description',
        priceKey: 'aiTools.elevenlabs.price',
        priceDetailsKey: 'aiTools.elevenlabs.priceDetails',
        icon: '🎤',
        isFree: false,
        category: 'voice',
        firstReleaseYear: 2022,
        lastVersionYear: 2024
    },
    {
        id: 'higgsfield',
        name: 'Higgsfield',
        url: 'https://higgsfield.ai',
        descriptionKey: 'aiTools.higgsfield.description',
        priceKey: 'aiTools.higgsfield.price',
        priceDetailsKey: 'aiTools.higgsfield.priceDetails',
        icon: '🎬',
        isFree: false,
        category: 'video',
        firstReleaseYear: 2023,
        lastVersionYear: 2025
    },
    {
        id: 'lipsyncstudio',
        name: 'Lipsync Studio',
        url: 'https://lipsync.studio',
        descriptionKey: 'aiTools.lipsyncstudio.description',
        priceKey: 'aiTools.lipsyncstudio.price',
        priceDetailsKey: 'aiTools.lipsyncstudio.priceDetails',
        icon: '👄',
        isFree: false,
        category: 'video',
        firstReleaseYear: 2023,
        lastVersionYear: 2025
    },
    {
        id: 'topazvideo',
        name: 'Topaz Video',
        url: 'https://www.topazlabs.com',
        descriptionKey: 'aiTools.topazvideo.description',
        priceKey: 'aiTools.topazvideo.price',
        priceDetailsKey: 'aiTools.topazvideo.priceDetails',
        icon: '🎥',
        isFree: false,
        category: 'video',
        firstReleaseYear: 2019,
        lastVersionYear: 2024
    },
    {
        id: 'chatgpt',
        name: 'ChatGPT',
        url: 'https://chatgpt.com',
        descriptionKey: 'aiTools.chatgpt.description',
        priceKey: 'aiTools.chatgpt.price',
        priceDetailsKey: 'aiTools.chatgpt.priceDetails',
        icon: '💬',
        isFree: false,
        category: 'other',
        firstReleaseYear: 2022,
        lastVersionYear: 2024
    },
    {
        id: 'gemini',
        name: 'Gemini',
        url: 'https://gemini.google.com',
        descriptionKey: 'aiTools.gemini.description',
        priceKey: 'aiTools.gemini.price',
        priceDetailsKey: 'aiTools.gemini.priceDetails',
        icon: '🤖',
        isFree: false,
        category: 'other',
        firstReleaseYear: 2023,
        lastVersionYear: 2024
    },
    {
        id: 'googleaistudio',
        name: 'Google AI Studio',
        url: 'https://aistudio.google.com',
        descriptionKey: 'aiTools.googleaistudio.description',
        priceKey: 'aiTools.googleaistudio.price',
        priceDetailsKey: 'aiTools.googleaistudio.priceDetails',
        icon: '🔬',
        isFree: false,
        category: 'development',
        firstReleaseYear: 2023,
        lastVersionYear: 2024
    },
    {
        id: 'figma',
        name: 'Figma',
        url: 'https://www.figma.com',
        descriptionKey: 'aiTools.figma.description',
        priceKey: 'aiTools.figma.price',
        priceDetailsKey: 'aiTools.figma.priceDetails',
        icon: '🎨',
        isFree: false,
        category: 'other',
        firstReleaseYear: 2016,
        lastVersionYear: 2024
    },
    {
        id: 'upscayl',
        name: 'Upscayl',
        url: 'https://upscayl.org',
        descriptionKey: 'aiTools.upscayl.description',
        priceKey: 'aiTools.upscayl.price',
        priceDetailsKey: 'aiTools.upscayl.priceDetails',
        icon: '🔍',
        isFree: true,
        category: 'image',
        firstReleaseYear: 2022,
        lastVersionYear: 2024
    },
    {
        id: 'runway',
        name: 'Runway',
        url: 'https://app.runwayml.com',
        descriptionKey: 'aiTools.runway.description',
        priceKey: 'aiTools.runway.price',
        priceDetailsKey: 'aiTools.runway.priceDetails',
        icon: '🎬',
        isFree: false,
        category: 'video',
        firstReleaseYear: 2018,
        lastVersionYear: 2024
    },
    {
        id: 'frameextractor',
        name: 'Frame Extractor',
        url: 'https://frame-extractor.com',
        descriptionKey: 'aiTools.frameextractor.description',
        priceKey: 'aiTools.frameextractor.price',
        priceDetailsKey: 'aiTools.frameextractor.priceDetails',
        icon: '🖼️',
        isFree: false,
        category: 'video',
        firstReleaseYear: 2023,
        lastVersionYear: 2024
    },
    {
        id: 'posebyart',
        name: 'PoseBy.Art',
        url: 'https://posemy.art',
        descriptionKey: 'aiTools.posebyart.description',
        priceKey: 'aiTools.posebyart.price',
        priceDetailsKey: 'aiTools.posebyart.priceDetails',
        icon: '🧍',
        isFree: false,
        category: 'image',
        firstReleaseYear: 2023,
        lastVersionYear: 2024
    }
];

